import Vue from 'vue';
import VueRouter from 'vue-router';

import DefaultOverlayPage from './pages/DefaultOverlay.vue';
import Bo6OverlayPage from './pages/Bo6OverlayPage.vue';
import NukeOverlayPage from './pages/NukeOverlay.vue';
import RankedOverlayPage from './pages/RankedOverlay.vue';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/ranked/:uid', component: RankedOverlayPage },
    { path: '/nuke/:uid', component: NukeOverlayPage },
    { path: '/bo6/:uid', component: Bo6OverlayPage },
    { path: '/camo/:uid', component: Bo6OverlayPage },
    { path: '/:uid', component: DefaultOverlayPage },
  ],
});

export default router;
